module.exports = __webpack_public_path__ + "img/logo1.78fe0466.png";